import { createSlice } from '@reduxjs/toolkit';

export const guestPdpBackUrl = createSlice({
  name: 'guestPdpBackUrl',
  initialState: {
    data: '',
  },

  reducers: {
    setGuestPdpBackUrl: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setGuestPdpBackUrl } = guestPdpBackUrl.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getGuestPdpBackUrl = (state) => {
  return state.guestPdpBackUrl.data;
};

export default guestPdpBackUrl.reducer;
